import { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import logo from "../svg/logo.png";
import redline from "../svg/redline.svg";
import button1 from "../svg/button.png";
import AnchorLink from "react-anchor-link-smooth-scroll";
import { useTranslation } from "react-i18next";
import Schedule from "./components/MainComponents/Schedule";
import TicketAvailability from "./components/MainComponents/TicketAvailability";
import SubmitProgramItem from "./components/MainComponents/SubmitProgramItem";
import LoadingDots from "./components/LoadingDots";

const HomePageUsers = () => {
  const [t, i18n] = useTranslation("global");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true); 
    emailjs
      .sendForm(
        "service_v8sqigr",
        "template_i8n2y0c",
        form.current,
        "kvvx_padstf0o02_b"
      )
      .then(
        (result) => {
          console.log(result.text);
          setLoading(false);
          setSubmitted(true);
        },
        (error) => {
          console.log(error.text);
          setLoading(false);
        }
      );
    e.target.reset();
  };

  let background = {
    backgroundImage: `url(${redline})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    padding: "4px",
    fontFamily: "Bebas Neue",
    width: "60%",
    marginLeft: "auto",
    marginRight: "auto",
  };
  let button = {
    backgroundImage: `url(${button1})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    padding: "4px",
  };
  return (
    <div className="App mx-auto pt-96">
      <div className="grid grid-cols-1 gap-4 justify-items-center pt-30">
        <div
          style={{
            fontFamily: "Bebas Neue",
            textShadow: "rgba(0,0,0,0.5) 1px 0 10px",
            marginTop: "-50px",
            width: "80%",
          }}
          className="drop-shadow text-white text-center lg:text-9xl text-6xl"
        >
          {t("home.game-studios")}
        </div>
        <div className="w-11/12 px-8 bg/50">
          <div
            className="text-white text-center text-s uppercase"
            style={background}
          >
            {t("home.main-location")}
          </div>
        </div>
        <div
          style={{ fontFamily: "Bebas Neue" }}
          className="text-white text-center text-5xl"
        >
          27.02.2026 - 01.03.2026
        </div>
        <div className="w-64 py-1.5 lg:pb-50">
          <AnchorLink style={{ fontFamily: "Bebas Neue" }} href="#moreInfo">
            <div className={`text-center  mx-auto`}>
              <button
                className="text-white w-48 h-20 text-center uppercase text-xl"
                style={{...button, width:"200px", height:"60px"}}
              >
                {t("home.see-more")}
              </button>
            </div>
          
          </AnchorLink>
        </div>
        <img
          src={logo}
          className="animate-spin-slow flex justify-center w-50 z-0"
          alt="logo"
          id="about"
        />
        <div className="pt-40"  id="moreInfo" style={{height:"300px"}}></div>
        <section className="grid grid-cols-1 gap-4 justify-items-center pt-12">
          <div
            style={{ fontFamily: "Bebas Neue" }}
            className="text-white text-center text-5xl"
          >
            {t("home.general-information")}
          </div>
          <div
            style={{ fontFamily: "Poppins", textAlignLast: "center" }}
            className="text-white text-justify text-base lg:w-1/2 w-11/12 place-items-center text-align-last:center"
          >
            {t("home.general-info-text-player")}
            <br />
            <br />
            {t("home.location")} {t("home.main-location")}
          </div>
          <div className="border-b-2 w-48 border-red-800 pt-10"></div>
        </section>
        <section id="program" className="grid grid-cols-1 gap-4 justify-items-center pt-12" style={{ width:'95%', overflow:'visible'}}>
          <SubmitProgramItem page="users"/>
          <div className="border-b-2 w-48 border-red-800 pt-10"></div>
        </section>
        <section className="grid grid-cols-1 gap-4 justify-items-center pt-12">
          <TicketAvailability page="users"/>
          <div className="border-b-2 w-48 border-red-800 pt-10"></div>
        </section>
        <section id="schedule" className="grid grid-cols-1 gap-4 justify-items-center pt-12" style={{maxWidth:'100%', width:'100%'}}>
          <Schedule page="users" language={i18n.language} />
        </section>
        <section className="grid grid-cols-1 gap-4 justify-items-center pt-12">
          <div
            style={{ fontFamily: "Bebas Neue" }}
            className="text-white text-center text-5xl"
          >
            {t("home.what-to-expect-title")}
          </div>
          <div
            style={{ fontFamily: "Poppins", textAlignLast: "center" }}
            className="text-white text-justify text-base lg:w-1/2 w-11/12 place-items-center text-align-last:center"
          >
            {t("home.what-to-expect-description")}
            <br />
            <br />
            <b>{t("home.what-to-expect-bold")}</b>
          </div>
          <div className="border-b-2 w-48 border-red-800 pt-10"></div>
        </section>
        <section className="grid lg:grid-cols-1 sm:grid-cols-1 gap-4 justify-items-center pt-12" id="contacts">
          <div className="grid grid-cols-1 justify-items-center">
            <div className="grid lg:grid-cols-2 w-full sm:grid-cols-1 gap-4 auto-cols-auto justify-items-center ">
              <div className="lg:w-3/5 pt-12 lg:justify-self-end">
                <div
                  style={{ fontFamily: "Bebas Neue" }}
                  className="text-white px-2 text-center lg:text-left text-5xl lg:justify-self-start justify-self-center lg:w-3/5"
                >
                  {t("home.contacts-form")}
                </div>
                <div
                  style={{ fontFamily: "Poppins" }}
                  className="px-2 text-white text-center lg:text-left text-base pt-2 lg:justify-self-start justify-self-center "
                >
                  {t("home.contact-form-text-player")}
                </div>
              </div>
            </div>
                <div className="grid lg:grid-cols-2 w-full sm:grid-cols-1 gap-4 auto-cols-auto justify-items-center ">
                {loading ? (
                  <div className="lg:w-3/5 sm:w-11/12 w-11/12 pt-0 lg:justify-self-end flex justify-center items-center">
                    <LoadingDots page="users" />
                  </div>
                ) : !submitted ? (
                  <form
                    ref={form}
                    onSubmit={sendEmail}
                    className="lg:w-3/5 sm:w-11/12 w-11/12 pt-12 lg:justify-self-end"
                  >
                    <div className="relative z-0 w-full mb-3 group bg-lime-900/50 w-90%">
                      <input
                        autoComplete="off"
                        type="text"
                        name="name"
                        id="name"
                        className="block pl-10 py-4 px-0 w-full text-base text-lime-300 bg-transparent appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                        placeholder=" "
                        required
                      />
                      <label
                        style={{ fontFamily: "Poppins" }}
                        className="peer-focus:font-medium absolute text-base text-white italic pl-10 dark:text-gray-400 duration-300 transform -translate-y-5 scale-75 top-5 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-lime-200 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-5"
                      >
                        {t("home.name-player")}
                      </label>
                    </div>
                    <div className="relative z-0 w-full mb-3 group bg-lime-900/50">
                      <input
                        autoComplete="off"
                        type="email"
                        name="email"
                        id="email"
                        className="block pl-10 py-4 px-0 w-full text-base text-lime-300 bg-transparent appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                        placeholder=" "
                        required
                      />
                      <label
                        style={{ fontFamily: "Poppins" }}
                        className="peer-focus:font-medium absolute text-base text-white italic pl-10  dark:text-gray-400 duration-300 transform -translate-y-5 scale-75 top-5 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-lime-200 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-5"
                      >
                        {t("home.e-mail-player")}
                      </label>
                    </div>

                    <div className="relative z-0 w-full h-96 mb-3 group bg-lime-900/50">
                      <textarea
                        maxLength="2000"
                        autoComplete="off"
                        type="text"
                        name="message"
                        id="message"
                        className="block resize-none pl-10 py-4 px-0 w-full h-52 mt-2 text-base text-lime-300 bg-transparent appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                        placeholder=" "
                        required
                      />
                      <label className="peer-focus:font-medium absolute text-base text-white italic pl-10 dark:text-gray-400 duration-300 transform -translate-y-5 scale-75 top-5 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-lime-200 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-5">
                        {t("home.your-message-player")}
                      </label>
                    </div>
                    <div className="w-48 z-0 w-full mb-3">
                      <div className="bg-black py-1.5">
                        <div className={`text-center ${window.innerWidth < 640 ? 'mx-auto' : ''}`}>
                          <button
                            className="text-white w-48 h-20 text-center uppercase text-xl outline-pink-900"
                            style={{ ...button, width: "200px", height: "60px" }}
                          >
                            {t("home.send")}
                          </button>
                          <div className="border-b-2 w-64 border-red-800 pt-4 mx-auto"></div>
                        </div>  
                      </div>
                    </div>
                  </form> ) : (
                    <div className="w-full pt-0 lg:justify-self-end text-white text-3xl text-center pt-12" style={{ width:'60%', fontFamily:"Bebas Neue" }}>
                      {t("home.thank-you-contact")}
                    </div>
                  )}
                  <iframe 
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2484.9916265955617!2d11.971946299999999!3d51.476668!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47a663daa70a6bf5%3A0x8d695ba67d78f1d7!2sHaus%2031%20-%20Institut%20f%C3%BCr%20Schulp%C3%A4dagogik%20und%20Grundschuldidaktik!5e0!3m2!1spt-PT!2spt!4v1772188550366!5m2!1spt-PT!2spt" 
                    // width="410"
                    height="494"
                    loading="lazy"
                    title="google maps"
                    className="pt-12 lg:w-3/5 w-full justify-self-start lg:w-3/5"
                  ></iframe>
                </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default HomePageUsers;
